// extracted by mini-css-extract-plugin
module.exports = {"own-message":"styles__own-message___3O7IB","content-size":"styles__content-size___2eQoq","sent-message":"styles__sent-message___4-EsW"};